<div>What is the date of the most recent specialist encounter? <br />(Found in consult note)</div>
<app-specialist-encounter-verifications
  [capture]="capture"
  [patientAttachment]="patientAttachment"
  (verificationChange)="onVerificationChange($event)"
  (verificationRemove)="onVerificationRemove($event)"
/>
<app-verification-validation [key]="validationKey" />
